module.exports = __webpack_public_path__ + "img/4life-logo.dab8e641.png";